<template>
  <div class="item">
    <span>{{itemData.text}}</span>
    <span class="iconfont iconguanbi1" @click="remove"></span>
  </div>
</template>
<script>
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    remove () {
      this.$emit('remove', this.itemData);
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 100px;
  height: 36px;
  background: #F8F8FC;
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 4px;
  & > .iconfont {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/multiSelector/selectorItem.vue